import React from 'react';
import styles from './MeasureToolContainer.module.scss';

const InlineIcon = ({ active }) => (
  <svg width="34" height="18" viewBox="0 0 34 18" fill="none">
    <line x1="2" y1="9" x2="10" y2="9" stroke={active ? '#fff' : '#cfcfcf'} strokeWidth="1.2" />
    <line x1="24" y1="9" x2="32" y2="9" stroke={active ? '#fff' : '#cfcfcf'} strokeWidth="1.2" />
    <text
      x="17"
      y="12"
      fill={active ? '#fff' : '#cfcfcf'}
      fontSize="7"
      textAnchor="middle"
      fontFamily="sans-serif">
      61°
    </text>
  </svg>
);

const OffsetIcon = ({ active }) => (
  <svg width="34" height="18" viewBox="0 0 34 18" fill="none">
    <line x1="2" y1="13" x2="32" y2="13" stroke={active ? '#fff' : '#cfcfcf'} strokeWidth="1.2" />
    <line
      x1="17"
      y1="13"
      x2="17"
      y2="7"
      stroke={active ? '#fff' : '#cfcfcf'}
      strokeWidth="1"
      strokeDasharray="1.5 1.5"
    />
    <text
      x="17"
      y="6"
      fill={active ? '#fff' : '#cfcfcf'}
      fontSize="7"
      textAnchor="middle"
      fontFamily="sans-serif">
      61°
    </text>
  </svg>
);

export const LayoutControl = ({ layout, onChange, isDefault, onToggleDefault }) => {
  const selected = layout === 'offset' ? 'offset' : 'inline';
  return (
    <div className={styles.layoutRow}>
      <div className={styles.layoutLabel}>Layout</div>
      <div className={styles.layoutSegmented}>
        <div
          className={`${styles.layoutOption} ${
            selected === 'inline' ? styles.layoutOptionSelected : ''
          }`}
          onClick={() => onChange('inline')}>
          <InlineIcon active={selected === 'inline'} />
          <div className={styles.layoutOptionLabel}>Inline</div>
        </div>
        <div
          className={`${styles.layoutOption} ${
            selected === 'offset' ? styles.layoutOptionSelected : ''
          }`}
          onClick={() => onChange('offset')}>
          <OffsetIcon active={selected === 'offset'} />
          <div className={styles.layoutOptionLabel}>Offset</div>
        </div>
      </div>
      <div className={styles.defaultWrap}>
        <div className={styles.layoutLabel}>Default</div>
        <div
          className={`${styles.pillToggle} ${isDefault ? styles.pillToggleOn : ''}`}
          onClick={() => onToggleDefault(!isDefault)}>
          <div className={`${styles.pillKnob} ${isDefault ? styles.pillKnobOn : ''}`} />
        </div>
      </div>
    </div>
  );
};
